(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["mpsb-brands-grid"] && !Shopify.designMode) return;
  try {
    
(() => {
  const normalize = value => value.normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase().replace(/[^a-z0-9]/g, '');
  function initBrandSearch() {
    const search = document.querySelector('[data-mpsb-brand-search]');
    if (!search) return;
    const input = search.querySelector('input');
    const clear = search.querySelector('[data-brand-clear]');
    const count = search.querySelector('[data-brand-count]');
    // Sections remain separate in the editor; storefront cards share one continuous grid.
    if (!window.Shopify?.designMode) {
      const primary = search.closest('[data-mpsb-brand-group]');
      const grid = primary?.querySelector('.mpsb-brands__grid');
      if (grid) {
        document.querySelectorAll('[data-mpsb-brand-group]').forEach(group => {
          if (group === primary || group.querySelector('.mpsb-brands__hero')) return;
          group.querySelectorAll('.mpsb-brands__grid > [data-brand-name]').forEach(item => {
            grid.appendChild(item);
          });
        });
      }
    }
    function filter() {
      const query = normalize(input.value);
      let total = 0;
      document.querySelectorAll('[data-mpsb-brand-group]').forEach(group => {
        let matches = 0;
        group.querySelectorAll('[data-brand-name]').forEach(item => {
          item.hidden = !normalize(item.dataset.brandName).includes(query);
          if (!item.hidden) matches++;
        });
        const isPrimary = group.contains(search);
        group.hidden = !isPrimary && matches === 0;
        group.querySelector('.mpsb-brands__grid').hidden = matches === 0;
        total += matches;
      });
      clear.hidden = input.value.length === 0;
      count.textContent = total ? total + (total === 1 ? ' marque' : ' marques') + (query ? ' trouvée' + (total === 1 ? '' : 's') : ' à découvrir') : 'Aucune marque trouvée. Essayez un autre nom.';
    }
    if (!search.dataset.ready) {
      search.dataset.ready = 'true';
      input.addEventListener('input', filter);
      clear.addEventListener('click', () => { input.value = ''; filter(); input.focus(); });
    }
    search.hidden = false;
    filter();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initBrandSearch);
  else initBrandSearch();
  document.addEventListener('shopify:section:load', initBrandSearch);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mpsb-home-categories"] && !Shopify.designMode) return;
  try {
    
  function initMpsbGalleries(root) {
    root.querySelectorAll('[data-mpsb-gallery]').forEach((gallery) => {
      if (gallery.dataset.galleryReady === 'true' || gallery.dataset.designMode === 'true') return;
      const button = gallery.querySelector('.mpsb-home-categories__more');
      const label = gallery.querySelector('[data-gallery-label]');
      const cards = Array.from(gallery.querySelectorAll('.mpsb-home-categories__grid > li'));
      if (!button || !label || cards.length <= 6) return;
      const desktop = window.matchMedia('(min-width: 1101px)');
      const initialCount = () => desktop.matches ? 8 : 6;
      let expanded = true;
      const setExpanded = (next, focusNewCards) => {
        expanded = next;
        cards.forEach((card, index) => { card.hidden = !expanded && index >= initialCount(); });
        button.setAttribute('aria-expanded', String(expanded));
        label.textContent = expanded ? button.dataset.collapseLabel : button.dataset.expandLabel;
        button.hidden = cards.length <= initialCount();
        if (focusNewCards) cards[initialCount()]?.querySelector('a')?.focus({ preventScroll: true });
      };
      button.addEventListener('click', (event) => {
        const next = !expanded;
        if (!next) {
          const first = cards[0];
          const lastVisible = cards[initialCount() - 1];
          const rect = lastVisible.getBoundingClientRect();
          if (rect.bottom < 0) first.scrollIntoView({ block: 'start', behavior: 'instant' });
        }
        setExpanded(next, next && event.detail === 0);
      });
      setExpanded(false, false);
      const resize = () => {
        if (!gallery.isConnected) { desktop.removeEventListener('change', resize); return; }
        setExpanded(expanded, false);
      };
      desktop.addEventListener('change', resize);
      gallery.dataset.galleryReady = 'true';
    });
  }
  initMpsbGalleries(document);
  document.addEventListener('shopify:section:load', (event) => initMpsbGalleries(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mpsb-latest-products"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mpsb-latest-products')) {
    customElements.define(
      'mpsb-latest-products',
      class extends HTMLElement {
        connectedCallback() {
          this.viewport = this.querySelector('[data-viewport]');
          this.track = this.querySelector('[data-track]');
          this.previousButton = this.querySelector('[data-direction="previous"]');
          this.nextButton = this.querySelector('[data-direction="next"]');
          this.handleScroll = this.updateButtons.bind(this);
          this.handleResize = this.updateButtons.bind(this);

          this.previousButton.addEventListener('click', () => this.move(-1));
          this.nextButton.addEventListener('click', () => this.move(1));
          this.viewport.addEventListener('scroll', this.handleScroll, { passive: true });
          window.addEventListener('resize', this.handleResize, { passive: true });
          this.loadProducts();
        }

        disconnectedCallback() {
          this.viewport?.removeEventListener('scroll', this.handleScroll);
          window.removeEventListener('resize', this.handleResize);
        }

        async loadProducts() {
          try {
            const response = await fetch(this.dataset.feedUrl, {
              credentials: 'same-origin',
              cache: 'no-store',
              headers: { 'X-Requested-With': 'XMLHttpRequest' },
            });

            if (!response.ok) throw new Error('Latest products unavailable');

            const markup = (await response.text()).trim();
            if (!markup) throw new Error('Latest products empty');

            this.track.innerHTML = markup;
            this.track.setAttribute('aria-busy', 'false');
            requestAnimationFrame(() => this.updateButtons());
          } catch (error) {
            this.hidden = true;
          }
        }

        move(direction) {
          this.viewport.scrollBy({
            left: direction * Math.max(this.viewport.clientWidth * 0.86, 280),
            behavior: 'smooth',
          });
        }

        updateButtons() {
          const maximum = Math.max(0, this.viewport.scrollWidth - this.viewport.clientWidth);
          this.previousButton.disabled = this.viewport.scrollLeft <= 2;
          this.nextButton.disabled = this.viewport.scrollLeft >= maximum - 2;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mpsb-pac-atlantic"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mpsb-pac-project')) {
    customElements.define('mpsb-pac-project', class extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector('[data-pac-dialog]');
        this.form = this.querySelector('form');
        this.steps = Array.from(this.querySelectorAll('[data-pac-step]'));
        this.current = 0;
        this.querySelectorAll('[data-pac-open]').forEach((button) => button.addEventListener('click', () => this.open()));
        this.querySelector('[data-pac-close]')?.addEventListener('click', () => this.close());
        this.dialog?.addEventListener('click', (event) => { if (event.target === this.dialog) this.close(); });
        this.querySelector('[data-pac-next]')?.addEventListener('click', () => this.next());
        this.querySelector('[data-pac-prev]')?.addEventListener('click', () => this.previous());
        this.querySelector('[data-pac-files]')?.addEventListener('change', (event) => this.listFiles(event.target.files));
        this.form?.addEventListener('submit', (event) => this.submit(event));
        this.querySelectorAll('[data-pac-help]').forEach((button) => button.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          const shouldOpen = button.getAttribute('aria-expanded') !== 'true';
          this.closeHelp();
          button.setAttribute('aria-expanded', String(shouldOpen));
        }));
        this.addEventListener('click', (event) => { if (!event.target.closest('.mpsb-pac__help')) this.closeHelp(); });
        this.querySelectorAll('input[type="date"]').forEach((input) => { input.min = new Date().toISOString().slice(0, 10); });
        this.render();
      }
      open() { this.dialog?.showModal(); document.documentElement.style.overflow = 'hidden'; this.steps[this.current]?.querySelector('input,select,textarea')?.focus(); }
      closeHelp() { this.querySelectorAll('[data-pac-help][aria-expanded="true"]').forEach((button) => button.setAttribute('aria-expanded', 'false')); }
      close() { this.closeHelp(); this.dialog?.close(); document.documentElement.style.overflow = ''; }
      validateStep() {
        const fields = Array.from(this.steps[this.current].querySelectorAll('input,select,textarea'));
        for (const field of fields) { if (!field.checkValidity()) { field.reportValidity(); field.focus(); return false; } }
        return true;
      }
      next() { if (!this.validateStep()) return; if (this.current < this.steps.length - 1) { this.current += 1; this.render(); } }
      previous() { if (this.current > 0) { this.current -= 1; this.render(); } }
      render() {
        this.closeHelp();
        this.steps.forEach((step, index) => { step.hidden = index !== this.current; });
        const number = this.querySelector('[data-pac-step-number]');
        const label = this.querySelector('[data-pac-step-label]');
        const progress = this.querySelector('[data-pac-progress]');
        if (number) number.textContent = String(this.current + 1);
        if (label) label.textContent = this.steps[this.current]?.dataset.label || '';
        if (progress) progress.style.width = `${((this.current + 1) / this.steps.length) * 100}%`;
        const previous = this.querySelector('[data-pac-prev]');
        const next = this.querySelector('[data-pac-next]');
        const submit = this.querySelector('[data-pac-submit]');
        if (previous) previous.hidden = this.current === 0;
        if (next) next.hidden = this.current === this.steps.length - 1;
        if (submit) submit.hidden = this.current !== this.steps.length - 1;
        this.querySelector('.mpsb-pac__dialog-shell')?.scrollTo({ top: 0, behavior: 'smooth' });
      }
      listFiles(files) {
        const list = this.querySelector('[data-pac-file-list]');
        if (!list) return;
        list.replaceChildren(...Array.from(files).map((file) => { const item = document.createElement('li'); item.textContent = `${file.name} — ${Math.ceil(file.size / 1024)} Ko`; return item; }));
      }
      leadPayload() {
        const payload = { schema_version: '1.0', source: 'shopify_pac_atlantic', page_url: window.location.href };
        this.querySelectorAll('[data-pac-key]').forEach((field) => {
          if ((field.type === 'radio' || field.type === 'checkbox') && !field.checked) return;
          const key = field.dataset.pacKey;
          const value = field.type === 'checkbox' ? true : field.value;
          if (payload[key] === undefined) payload[key] = value;
          else if (Array.isArray(payload[key])) payload[key].push(value);
          else payload[key] = [payload[key], value];
        });
        return payload;
      }
      async submit(event) {
        if (!this.validateStep()) { event.preventDefault(); return; }
        const endpoint = this.dataset.endpoint?.trim();
        if (!endpoint) return;
        event.preventDefault();
        const error = this.querySelector('[data-pac-error]');
        const success = this.querySelector('[data-pac-success]');
        const button = this.querySelector('[data-pac-submit]');
        error.hidden = true; success.hidden = true; button.disabled = true; button.textContent = 'Envoi en cours…';
        const body = new FormData();
        body.append('payload', JSON.stringify(this.leadPayload()));
        Array.from(this.querySelector('[data-pac-files]')?.files || []).forEach((file) => body.append('files[]', file, file.name));
        try {
          const response = await fetch(endpoint, { method: 'POST', body, headers: { Accept: 'application/json' } });
          const result = await response.json().catch(() => ({}));
          if (!response.ok || result.success === false) throw new Error(result.message || 'La demande n’a pas pu être transmise.');
          const reference = result.reference ? ` Référence : ${result.reference}` : '';
          success.textContent = `Votre demande a bien été transmise à MPSB Distribution.${reference}`;
          success.hidden = false; this.form.reset(); this.current = 0; this.render();
        } catch (exception) {
          error.textContent = `${exception.message} Vous pouvez réessayer ou contacter directement MPSB Distribution.`; error.hidden = false;
        } finally { button.disabled = false; button.textContent = 'Envoyer mon projet'; }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mpsb-poloplast-xs"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mpsb-polo-page')) {
    customElements.define('mpsb-polo-page', class extends HTMLElement {
      connectedCallback() {
        this.abort?.abort();
        this.abort = new AbortController();
        const signal = this.abort.signal;
        const animation = this.querySelector('[data-polo-animation]');
        const animationButton = this.querySelector('[data-polo-animate]');
        const canvas = this.querySelector('.polo__animation canvas');
        if (animation && animationButton && canvas) {
          const freeze = () => {canvas.getContext('2d').drawImage(animation, 0, 0, 450, 450); canvas.hidden = false; animation.hidden = true; animationButton.setAttribute('aria-pressed', 'false'); animationButton.textContent = animationButton.dataset.play; animationButton.disabled = false;};
          if (animation.complete && animation.naturalWidth) freeze();
          else animation.addEventListener('load', freeze, {once:true, signal});
          animationButton.addEventListener('click', () => {if (animation.hidden) {canvas.hidden = true; animation.hidden = false; animationButton.setAttribute('aria-pressed','true'); animationButton.textContent = animationButton.dataset.pause;} else freeze();}, {signal});
        }
        this.querySelector('[data-polo-video]')?.addEventListener('click', event => {
          const button = event.currentTarget;
          const iframe = document.createElement('iframe');
          iframe.src = 'https://www.youtube-nocookie.com/embed/nv0t1ZJWYFU?autoplay=1&rel=0';
          iframe.title = button.dataset.title;
          iframe.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
          iframe.allowFullscreen = true;
          iframe.referrerPolicy = 'strict-origin-when-cross-origin';
          button.parentElement.replaceChildren(iframe);
          iframe.focus();
        }, {signal});
        const track = this.querySelector('.polo__products');
        if (!track) return;
        const controls = this.querySelector('.polo__carousel-controls');
        const prev = this.querySelector('[data-polo-prev]');
        const next = this.querySelector('[data-polo-next]');
        const update = () => {const end = track.scrollWidth - track.clientWidth; controls.hidden = end < 3; prev.disabled = track.scrollLeft <= 4; next.disabled = track.scrollLeft >= end - 4;};
        const move = direction => track.scrollBy({left: direction * (track.querySelector('li').getBoundingClientRect().width + 20), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
        prev.addEventListener('click', () => move(-1), {signal});
        next.addEventListener('click', () => move(1), {signal});
        track.addEventListener('scroll', update, {signal, passive: true});
        this.observer = new ResizeObserver(update);
        this.observer.observe(track);
        update();
      }
      disconnectedCallback() {this.abort?.abort(); this.observer?.disconnect();}
    });
  }

  } catch(e) { console.error(e); }
})();
})();
